import { isOfflineMode } from '@atlaskit/editor-common/connectivity/isOfflineMode';
import type { Mode } from '@atlaskit/editor-common/connectivity/mode';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/useSharedPluginStateWithSelector';

import { type FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';

type ConnectivitySelectorState = {
	connectivityState?: { mode?: Mode };
};

/**
 * Whether the editor has lost its network connection. Starting a review needs the network, so
 * review entry points in the panel are disabled while this is `true`.
 */
export const useIsOffline = (api: FullPageEditorPresetAPI | undefined): boolean =>
	useSharedPluginStateWithSelector(
		api,
		['connectivity'],
		({ connectivityState }: ConnectivitySelectorState) => isOfflineMode(connectivityState?.mode),
	);
